// extracted by mini-css-extract-plugin
export default {"right-section__content":"rightSection_right-section__content__ITtsd","right-section__location":"rightSection_right-section__location__nerJ7"};